import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetInvoiceListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    selectedCurrentCompany: CustomSingleSelectModel | undefined
    selectedOperationType: CustomSingleSelectModel | undefined
    selectedCurrencyType: CustomSingleSelectModel | undefined
    selectedInvoiceStatus: CustomSingleSelectModel | undefined
    invoiceDateStart: string | undefined
    invoiceDateEnd: string | undefined
    paymentDateStart: string | undefined
    paymentDateEnd: string | undefined
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetInvoiceListPagingAndFilterRequest: GetInvoiceListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    selectedCurrentCompany: undefined,
    selectedOperationType: undefined,
    selectedCurrencyType: undefined,
    selectedInvoiceStatus: undefined,
    invoiceDateStart: undefined,
    invoiceDateEnd: undefined,
    paymentDateStart: undefined,
    paymentDateEnd: undefined,
    isSale: false,
    isPurchase: false,
    isRefund: false,
    columnFilters: []
}